import { render, staticRenderFns } from "./ConferenceAdminCompanyModal.vue?vue&type=template&id=b08e0234&scoped=true"
import script from "./ConferenceAdminCompanyModal.vue?vue&type=script&lang=js"
export * from "./ConferenceAdminCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./ConferenceAdminCompanyModal.vue?vue&type=style&index=0&id=b08e0234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08e0234",
  null
  
)

export default component.exports